import { FC } from "react";
import {
    Select,
    MenuItem,
    Stack,
    Typography,
} from "@mui/material";
import { useOrganizationContext } from "../../context/OrganizationContext";

const RoleSelector: FC = () => {
    const {
        selectedRoleId,
        availableRoles,
        switchRole,
    } = useOrganizationContext();

    if (availableRoles.length === 0) {
        return null;
    }

    if (availableRoles.length === 1) {
        return (
            <Stack direction="row" spacing={1} alignItems="center">
                <Typography fontFamily="Montserrat" fontSize={12}>
                    Rol:
                </Typography>
                <Typography
                    fontWeight="bold"
                    fontSize={12}
                    fontFamily="Montserrat"
                    color="#336B87"
                >
                    {availableRoles[0].rol}
                </Typography>
            </Stack>
        );
    }

    return (
        <Stack direction="row" spacing={1} alignItems="center">
            <Typography fontFamily="Montserrat" fontSize={12}>
                Rol:
            </Typography>
            <Select
                value={selectedRoleId || ""}
                onChange={(e) => switchRole(e.target.value)}
                size="small"
                sx={{
                    minWidth: 120,
                    fontFamily: "Montserrat",
                    fontSize: 12,
                    fontWeight: "bold",
                    color: "#336B87",
                    "& .MuiOutlinedInput-notchedOutline": {
                        border: "none",
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                        border: "1px solid #336B87",
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        border: "1px solid #336B87",
                    },
                }}
            >
                {availableRoles.map((role) => (
                    <MenuItem
                        key={role.id_rol}
                        value={role.id_rol}
                        sx={{
                            fontFamily: "Montserrat",
                            fontSize: 12,
                        }}
                    >
                        <Typography fontSize={12} fontFamily="Montserrat">
                            {role.rol}
                        </Typography>
                    </MenuItem>
                ))}
            </Select>
        </Stack>
    );
};

export default RoleSelector;
